import BaseController from "./BaseController";
import EndpointPaths from "../common/EndpointPaths";
import ListMassProductsRequest from "@/models/server/requests/ListMassProductsRequest";
import MassProduct from "@/models/server/MassProduct";
import SaveMassProductRequest from "@/models/server/requests/SaveMassProductRequest";
import SaveMassProductResponse from "@/models/server/responses/SaveMassProductResponse";
import {IPagedList} from "@renta-apps/athenaeum-toolkit";
import GetMassProductsRequest from "@/models/server/requests/GetMassProductsRequest";

class MassProductsController extends BaseController {

    public async listMassProductsAsync(request: ListMassProductsRequest): Promise<IPagedList<MassProduct>> {
        return await this.postAsync(EndpointPaths.MassProductPaths.ListMassProducts, request);
    }

    public async getMassProductsAsync(request: GetMassProductsRequest): Promise<MassProduct[]> {
        return await this.postAsync(EndpointPaths.MassProductPaths.GetMassProducts, request);
    }

    public async saveMassProductAsync(request: SaveMassProductRequest): Promise<SaveMassProductResponse> {
        return await this.postAsync(EndpointPaths.MassProductPaths.SaveMassProduct, request);
    }

    public async deleteMassProductAsync(massProductId: string): Promise<boolean> {
        return await this.postAsync(EndpointPaths.MassProductPaths.DeleteMassProduct, massProductId);
    }

    public async restoreMassProductAsync(massProductId: string): Promise<void> {
        return await this.postAsync(EndpointPaths.MassProductPaths.RestoreMassProduct, massProductId);
    }
}

export default new MassProductsController();